import { render, staticRenderFns } from "./mobile_yam.vue?vue&type=template&id=6b797687&"
import script from "./mobile_yam.vue?vue&type=script&lang=js&"
export * from "./mobile_yam.vue?vue&type=script&lang=js&"
import style0 from "./mobile_yam.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "mobile_yam.vue"
export default component.exports